import React from "react";
import AppDialog from "./AppDialog";
import { SVG } from "../../constants/assetLists";
import AppButton from "./AppButton";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children?: React.ReactNode;
};

function AppLoginDialog({
  open,
  onClose,
  onConfirm,
}: Props) {
  return (
    <AppDialog
      showModel={open}
      onClose={onClose}
      showCloseIcon={true}
      width={550}
      containerClasses="!py-0 !pt-4"
    >
      <div className="flex flex-row-reverse items-start justify-between relative">
        <div className="">
          <p className="text-[32px]">החשבון שלך מוכן.</p>
          <p className="text-[20px] w-[85%] mt-1">
            לפני שמתחילים, יש להחליף את הסיסמה הזמנית
          </p>
          <AppButton
            onClick={onConfirm}
            variant="primary"
            className="mt-6 w-[70%] !py-3.5 text-center flex items-center justify-center"
          >
            החלפת סיסמה
          </AppButton>
        </div>
        <div>
          <img
            src={SVG.checkTickBg}
            alt="icon"
            className="w-[260px] h-[230px] object-cover"
          />
        </div>
      </div>
    </AppDialog>
  );
}

export default AppLoginDialog;
